<template lang="pug">
  #app
    Header
    Aside
    Content

</template>

<style scoped>

</style>
<script>
import Header from "./components/Header";
import Aside from "./components/Aside";
import Content from "./components/Content";

export default {
  name: "app",
  components: {Aside, Header,Content}
}
</script>
